import React, { useContext } from "react";
import { Button } from "antd";
import Status from "./status";
import formatPrice from "../../../components/formatPrice";
import datetimeParser from "../../../components/datetimeParser";
import { useBlockedRows } from "../../../context/BlockedRowsContext";
import CopyData from "../../../components/CopyData";
import {
  LockOutlined
} from '@ant-design/icons';

const TableColumns = () => {
  const blockedRows = useBlockedRows().blockedRows
  const columns = [
    {
      title: 'LP',
      dataIndex: 'msr_wplywy_id',
      key: 'msr_wplywy_id',
      width: "100px",
      render: (item, record) => {
        const isBlocked = blockedRows.some(item => item.msr_wplywy_msr_wplywy_id == record.msr_wplywy_id);
        return (
          <div style={{display: 'flex', alignItems: 'center', gap: "10px"}}>#{item} {isBlocked ? <LockOutlined style={{fontSize: '20px'}} /> : ''} </div>
        );
      },
    },
    {
      title: 'ID wpływu',
      dataIndex: 'msr_wplywy_own_id',
      width: "150px",
      key: 'msr_wplywy_own_id',
      render: (item) => (
        <div className="monospace" style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
        <CopyData item={'#'+item} />
          #{item}
        </div>      
      ),
    },
    {
      title: 'Osoby',
      dataIndex: 'persons',
      width: "250px",
      key: 'persons',
      render: (item, record) => (
        <div>
          <div>
            {record.persons.length > 0 
              ? record.persons.length === 1 
                ? <><CopyData item={`${record.persons[0].msr_persons_name} ${record.persons[0].msr_persons_lastname}`} /> {record.persons[0].msr_persons_name} {record.persons[0].msr_persons_lastname}</> 
                : `${record.persons.length} osoby`
              : 'Brak danych'}
          </div>
        </div>
      ),
    },
    {
      title: 'Kwota wpływu',
      width: '200px',
      dataIndex: 'msr_wplywy_primary_amount',
      key: 'msr_wplywy_primary_amount',
      render: (item) => (
        <div className="monospace" style={{ fontSize: '14px', fontWeight: 700, textAlign: 'right' }}>
          {formatPrice(item)} zł
        </div>
      ),
    },
    {
      title: 'Kwota odliczenia',
      width: '200px',
      dataIndex: 'msr_wplywy_primary_deduction',
      key: 'msr_wplywy_primary_deduction',
      render: (item) => (
        <div className="monospace" style={{ fontSize: '14px', fontWeight: 700, textAlign: 'right' }}>
          {formatPrice(item)} zł
        </div>
      ),
    },
    {
      title: 'Rachunek wpływu',
      width: '200px',
      dataIndex: 'msr_bank_accounts_name',
      key: 'msr_bank_accounts_name',
      render: (item) => (
        <div style={{ fontSize: '14px', fontWeight: 700, textAlign: 'right' }}>
          {item}
        </div>
      ),
    },
    {
      title: 'Data wpływu',
      dataIndex: 'msr_wplywy_date_in',
      key: 'msr_wplywy_date_in',
      width: "150px",
      render: (item) => (
        <div>
          {datetimeParser(item, "YYYY-MM-DD")}
        </div>
      ),
    },
        {
          title: 'Data wpływu na rachunek rozliczeniowy',
          dataIndex: 'msr_wplywy_date_forward',
          key: 'msr_wplywy_date_forward',
          width: "250px",
          render: (item) => (
            <div>
              {item && item != 'null' ? datetimeParser(item, "YYYY-MM-DD") : 'Nie przekazano'}
            </div>
          ),
        },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (item, record) => (
        record.msr_wplywy_primary_amount - record.msr_wplywy_primary_deduction == 0 ? 'Odliczenie wstępne' :
        record.persons.length > 0 
          ? record.persons.length === 1 
            ? <Status wplyw={record.persons[0]} /> 
            : 'Rozwiń aby poznać statusy osób'
          : ('Brak danych')
      ),
    },
    {
      title: 'Ostatnia zmiana',
      dataIndex: 'msr_wplywy_last_update',
      key: 'msr_wplywy_last_update',
      render: (item) => (
        <div style={{display: 'flex', gap: '5px', alignItems: 'center'}}>
          <div>{datetimeParser(item, "YYYY-MM-DD")}</div>
          <div style={{padding: '2px 5px', background: 'rgb(233 233 233)', fontSize: '13px', color: 'black',  borderRadius: '5px', width: 'fit-content', height: 'fit-content'}}>
          {datetimeParser(item, "HH:mm")}
          </div>
        </div>
      ),
    },
  ];

  return columns;
};

export default TableColumns;
